import { getAccessLevel, isMember } from "./permissions";

export function buildPortalUser(authUser, users = [], images = []) {
  const signedInUser = authUser && authUser.name
    ? {
        type: "attendee",
        email: authUser.email,
        email_verified: authUser.email_verified,
      }
    : { type: "basic" };
  const login = authUser && authUser.name ? authUser.name.toLowerCase() : "";
  const storedUser = users.find(({ email }) => email === login);
  const portalUser = storedUser ? { ...storedUser } : signedInUser;

  if (storedUser) {
    portalUser.userImage = images.find((file) =>
      file.includes(`profile___${storedUser.id}___`),
    );
  }

  portalUser.access = getAccessLevel(portalUser);
  portalUser.member = isMember(portalUser);
  return portalUser;
}

export function selectMembers(users = []) {
  return users.filter(isMember);
}
